/* Generated code; Use nx run packages/systems/ui/icons:generate-icons
  * to regenerate this file.
  */
import React, {SVGProps} from 'react';
import type { IconProps } from '@packages/utilities/icon-support';
const createElement = React.createElement;
export default /*#__PURE__#*/ function CmsDraftPage(props: IconProps): React.ReactElement<SVGProps<SVGElement>> {
  const inputScale = props.scale ?? 1;
  const scale = typeof inputScale === 'number' ? inputScale : parseInt(inputScale, 10);
  return createElement('svg', {
      'data-icon': 'CmsDraftPage',
      'aria-hidden': true,
      focusable: false,
      width:  13 * scale,
      height: 12 * scale,
      viewBox: '0 0 13 12',
      y: props.y != null ? props.y : undefined,
      x: props.x != null ? props.x : undefined,
      className: 'bem-Svg' + (props.className ? ' ' + props.className : ''),
      style: {...{
        display: 'block',
      }, ...props.style}
    },createElement('path', {"fill":"currentColor","d":"M10.596 4.732 4.94 10.39.696 11.802 2.11 7.56l5.66-5.655L9.182.49a1 1 0 0 1 1.414 0l1.414 1.414a1 1 0 0 1 0 1.414z"}),createElement('path', {"fill":"rgba(255,255,255,.7)","d":"m4.4 9.515 4.78-4.783-1.412-1.414L2.985 8.1l-.707 2.122 2.12-.707zm4.074-6.903L9.89 4.025 11.3 2.61 9.89 1.2 8.474 2.61z"}))
}
